export const LOGIN_API_URL = '/auth/login';
export const LOGIN_WITH_PIN_URL = '/auth/verifyPin';
export const FORGOT_PASSWORD_URL = '/auth/forgotpassword';
export const CHANGE_PASSWORD_URL = '/auth/resetPassword';
export const FORGOT_PASSWORD_PIN_URL = '/auth/forgotOtpVerify';
export const SET_USER_PIN_URL = '/auth/updatePin';
export const GET_USER_COMPANY_URL = '/users/companies';
export const GET_USER_DIVISION_URL = '/users/divisions';
export const CHANGE_CURRENT_PASSWORD_URL = '/auth/updErpPassword';
export const GET_USER_PREF_CONFIG_URL = '/users/getUserPrefConfig';
